import EmblaCarousel from 'embla-carousel'

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const _variant = urlParams.get('variant')

if(window.location.pathname.includes('/products/') && document.querySelector('.embla-pdp__viewport')){

  const addThumbBtnsClickHandlers = (emblaApiMain, emblaApiThumb) => {
    const slidesThumbs = emblaApiThumb.slideNodes()
  
    const scrollToIndex = slidesThumbs.map(
      (_, index) => () => emblaApiMain.scrollTo(index)
    )
  
    slidesThumbs.forEach((slideNode, index) => {
      slideNode.addEventListener('click', scrollToIndex[index], false)
    })
  
    return () => {
      slidesThumbs.forEach((slideNode, index) => {
        slideNode.removeEventListener('click', scrollToIndex[index], false)
      })
    }
  }
  
  const addToggleThumbBtnsActive = (emblaApiMain, emblaApiThumb) => {
    const slidesThumbs = emblaApiThumb.slideNodes()
  
    const toggleThumbBtnsState = () => {
      emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap())
      const previous = emblaApiMain.previousScrollSnap()
      const selected = emblaApiMain.selectedScrollSnap()
      slidesThumbs[previous].classList.remove('embla-thumbs__slide--selected')
      slidesThumbs[selected].classList.add('embla-thumbs__slide--selected')
    }
  
    emblaApiMain.on('select', toggleThumbBtnsState)
    emblaApiThumb.on('init', toggleThumbBtnsState)
  
    return () => {
      const selected = emblaApiMain.selectedScrollSnap()
      slidesThumbs[selected].classList.remove('embla-thumbs__slide--selected')
    }
  }
  
  
  const addTogglePrevNextBtnsActive = (emblaApiMain, prevBtn, nextBtn) => {
    const togglePrevNextBtnsState = () => {
      if (emblaApiMain.canScrollPrev()) prevBtn.removeAttribute('disabled')
      else prevBtn.setAttribute('disabled', 'disabled')
  
      if (emblaApiMain.canScrollNext()) nextBtn.removeAttribute('disabled')
      else nextBtn.setAttribute('disabled', 'disabled')
    }
  
    emblaApiMain
      .on('select', togglePrevNextBtnsState)
      .on('init', togglePrevNextBtnsState)
      .on('reInit', togglePrevNextBtnsState)
  
    return () => {
      prevBtn.removeAttribute('disabled')
      nextBtn.removeAttribute('disabled')
    }
  }
  
  const addPrevNextBtnsClickHandlers = (emblaApiMain, prevBtn, nextBtn) => {
    const scrollPrev = () => emblaApiMain.scrollPrev()
    const scrollNext = () => emblaApiMain.scrollNext()
    prevBtn.addEventListener('click', scrollPrev, false)
    nextBtn.addEventListener('click', scrollNext, false)
  
    const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
      emblaApiMain,
      prevBtn,
      nextBtn
    )
  
    return () => {
      removeTogglePrevNextBtnsActive()
      prevBtn.removeEventListener('click', scrollPrev, false)
      nextBtn.removeEventListener('click', scrollNext, false)
    }
  }
  
  
  const OPTIONS = {loop: true}
  const OPTIONS_THUMBS = {
    containScroll: 'keepSnaps',
    dragFree: true
  }
  
  const emblaNode = document.querySelector('.product-main-swiper')
  
  const viewportNodeMainCarousel = document.querySelector('.embla-pdp__viewport')
  const viewportNodeThumbCarousel = document.querySelector(
    '.embla-thumbs__viewport'
  )
  const emblaApiMain = EmblaCarousel(viewportNodeMainCarousel, OPTIONS)
  const emblaApiThumb = EmblaCarousel(viewportNodeThumbCarousel, OPTIONS_THUMBS)
  
  const prevBtn = emblaNode.querySelector('.embla__button--prev')
  const nextBtn = emblaNode.querySelector('.embla__button--next')
  
  const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
    emblaApiMain,
    emblaApiThumb
  )
  
  const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
    emblaApiMain,
    emblaApiThumb
  )
  
  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
    emblaApiMain,
    prevBtn,
    nextBtn
  )
  
  emblaApiMain
    .on('destroy', removeThumbBtnsClickHandlers)
    .on('destroy', removeToggleThumbBtnsActive)
    .on('destroy', removePrevNextBtnsClickHandlers)
  
  
  emblaApiThumb
    .on('destroy', removeThumbBtnsClickHandlers)
    .on('destroy', removeToggleThumbBtnsActive)
  
  
    function findImageIndex(id, jump) {
      document.querySelectorAll('.embla-pdp__viewport .embla__slide').forEach((s,i)=>{
        let vid = s.getAttribute('data-variant-id');
        if(id == vid){
          scrollToByElement(s, jump);
          return s;
        } else {
          return null;
        }
      })
    }


    function scrollToByElement(slideElement, jump) {
      const slideIndex = emblaApiMain.slideNodes().indexOf(slideElement)
      emblaApiMain.scrollTo(slideIndex, jump);
      emblaApiThumb.scrollTo(slideIndex, jump);
    }
    
    
    document.querySelectorAll('.image-jumper').forEach((el)=>{
      el.addEventListener('click',(e)=>{
        let _id = e.target.getAttribute('data-variant-id')
          if(!_id){
          } else {
            findImageIndex(_id, false);
          }
      })
    })
  
      if(_variant){
        findImageIndex(_variant, true);
      }
  
} else {
  return null;
}

